import { API_BASE_URL } from 'config'

import axios from 'axios'
import PropTypes from 'prop-types'
import slugify from 'slugify'
import find from 'lodash/find'

/** Redux and Kea */
import { kea } from 'kea'
import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'

import FiltersLogic from 'containers/Filters/logic'
import ResultsLogic from 'containers/Results/logic'

/** Contants */
const EntitiesEndpoint = `${API_BASE_URL}/public/entity/`

export default kea({

  connect: {
    actions: [
      FiltersLogic, [
        'filter',
        'setPressureOption',
        'setTensionOption',
        'setFilters'
      ],
      ResultsLogic, [
        'setOpened'
      ]
    ],
    props: [
      FiltersLogic, [
        'current',
        'filters'
      ],
      ResultsLogic, [
        'opened'
      ]
    ]
  },

  /** All default app actions */
  actions: () => ({
    setResults: (results) => ({ results }),
    setFetchError: (message) => ({ message })
  }),

  reducers: ({ actions }) => ({
    results: [[], PropTypes.array, {
      [actions.setResults]: (_, payload) => payload.results
    }],

    isLoading: [false, PropTypes.bool, {
      [actions.setResults]: () => false,
      [actions.setFetchError]: () => false,
      [actions.filter]: () => true
    }]
  }),

  selectors: () => ({
    isCompany: [
      () => [],
      () => window.location.href.indexOf('/empresas') !== -1,
      PropTypes.any
    ]
  }),

  /**
   * Do something when actions are triggered
   */
  takeLatest: ({ actions, workers }) => ({
    [actions.filter]: [workers.fetchResults, workers.pushState],
    [actions.setPressureOption]: workers.fetchResults,
    [actions.setTensionOption]: workers.fetchResults,
    [actions.setFilters]: workers.setCurrentFilterFromUrl,
    [actions.setResults]: workers.setCurrentOpenedResultFromUrl,
    [actions.setOpened]: workers.pushState
  }),

  /**
   * Fetchers
   */
  workers: {

    /**
     * Fetches the results
     * @param {Object} action Caller action
     */
    * fetchResults (action) {
      const { setResults, setFetchError } = this.actions
      const { isCompany } = this.props
      let { selectedTension, selectedPressure, current } = yield FiltersLogic.get()

      const options = {
        electricity_tension_types: selectedTension || '',
        gas_tension_types: selectedPressure || ''
      }

      if (!isCompany) {
        options.electricity_tension_types = 'btn'
        options.gas_tension_types = 'lp'
        options.market_segments = 'd'
      } else {
        options.market_segments = 'nd_gd'
      }

      if (current.slug.indexOf('e') === -1) {
        delete options.electricity_tension_types
      }

      if (current.slug.indexOf('g') === -1) {
        delete options.gas_tension_types
      }

      const filters = {
        offer_types: current.id,
        limit: 1000,
        is_last_resort: false,

        ...options
      }

      yield delay(100)
      try {
        const request = yield call(axios.get, EntitiesEndpoint, { params: filters })
        yield put(setResults(request.data.results))
      } catch (error) {
        yield put(setFetchError(error))
      }
    },

    * setCurrentOpenedResultFromUrl () {
      try {
        const { setOpened } = this.actions
        const results = yield this.get('results')
        const hash = window.location.hash

        if (hash) {
          const path = hash.substring(2)
          const split = path.split('/')
          if (split.length > 1 && split[1]) {
            const slug = split[1]

            const createSlug = (str) => slugify(str).toLowerCase()
            const slugEqual = ({ designation }) => createSlug(designation) === slug
            const result = find(results, slugEqual)
            result.fromUrl = true

            yield put(setOpened(result))
          }
        }
      } catch (e) {

      }
    },

    * setCurrentFilterFromUrl () {
      try {
        const { filter } = this.actions

        const filters = yield FiltersLogic.get('filters')
        const hash = window.location.hash

        if (hash) {
          const path = hash.substring(2)
          const split = path.split('/')
          if (split.length) {
            const slugFromHash = split[0]

            const createSlug = (str) => slugify(str).toLowerCase()
            const slugEqual = ({ name }) => createSlug(name) === slugFromHash
            const { id, slug } = find(filters, slugEqual)
            yield put(filter({ id, slug, fromUrl: true }))
          }
        }
      } catch (e) {

      }
    },

    * pushState (action) {
      const filterFromUrl = action.payload.filter && action.payload.filter.fromUrl
      const resultFromUrl = action.payload.item && action.payload.item.fromUrl

      if (!filterFromUrl && !resultFromUrl) {
        const opened = yield ResultsLogic.get('opened')
        const current = yield FiltersLogic.get('current')
        const currentFilterId = current.id
        const filters = yield FiltersLogic.get('filters')

        let slug = ''
        let filterSlug = ''

        if (opened) {
          slug = slugify(opened.designation).toLowerCase()
        }

        if (currentFilterId) {
          const currentFilterObject = find(filters, ({ id }) => id === currentFilterId)
          filterSlug = slugify(currentFilterObject.name).toLowerCase()
        }

        if (currentFilterId !== undefined || opened) {
          const url = `#/${filterSlug}/${slug}`
          window.history.pushState('', '', url)
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/containers/App/logic.js